module.exports = __webpack_public_path__ + "static/media/s4.a846ba63.ogg";